export var intialStateGoals = {
    goalsRowsData: [],
    goalsActionMap: {},
    lastEvaluatedKey: '',
    loading: false,
    totalRows: 0,
    currentPage: 1,
    notes: [],
    notesLoading: false,
};
